import Vue from 'vue';
import Vuex, { Module } from 'vuex';
import axios from 'axios';
import { Authenticate, endpoints } from '../endpoints/endpoints';
import { handleError } from '@/utils/helperFunctions';

import { Products } from '@/definitions/definitions';

Vue.use(Vuex);

export const products: Module<Products, any> = {
  state: {
    productFilterOptions: {},
    productSearchResults: {},
    productFiltersQueryString: null,
    productSearchKeyword: null,
    notesProviders: null,
    structuredNotes: null,
    mutualFunds: null,
    activelyManagedCertificates: null,
    activelyManagedCertificateProviders: null,
    funds: {
      TopPerformingFunds: null,
      TopGBPFunds: null,
      TopUSDFunds: null,
      TopEUROFunds: null,
      Top5StarRating: null,
      Top4StarRating: null,
      TopDailyTradedFunds: null,
      MostActivelyBought: null,
      MostActivelySold: null,
      fundsSummary: null,
    },
    ETFTopFive: {
      TopPerformingFunds: null,
      TopGBPFunds: null,
      TopUSDFunds: null,
      TopEUROFunds: null,
      Top5StarRating: null,
      Top4StarRating: null,
      TopDailyTradedFunds: null,
      MostActivelyBought: null,
      MostActivelySold: null,
      fundsSummary: null,
    },
    equitiesTopFive: {
      TopPerformingFunds: null,
      TopGBPFunds: null,
      TopUSDFunds: null,
      TopEUROFunds: null,
      Top5StarRating: null,
      Top4StarRating: null,
      TopDailyTradedFunds: null,
      MostActivelyBought: null,
      MostActivelySold: null,
      fundsSummary: null,
    },
    ETFs: null,
    lowCostETFs: null,
    DFMs: null,
    DFMDetails: null,
    fixedIncome: null,
    fixedIncomeProviders: null,
    equities: null,
  },
  mutations: {
    setProductFilterOptions(state, data) {
      state.productFilterOptions = data;
    },
    setProductSearchResults(state, data) {
      state.productSearchResults = data;
    },
    updateProductFiltersQueryString(state, data) {
      state.productFiltersQueryString = data;
    },
    updateProductSearchKeyword(state, data) {
      state.productSearchKeyword = data;
    },
    setNotesProviders(state, data) {
      state.notesProviders = data;
    },
    setStructuredNotes(state, data) {
      state.structuredNotes = data;
    },
    setMutualFunds(state, data) {
      state.mutualFunds = data;
    },
    setEquityFunds(state, data) {
      state.equities = data;
    },
    setTopPerformingFunds(state, data) {
      state.funds.TopPerformingFunds = data;
    },
    setTopGBPFunds(state, data) {
      state.funds.TopGBPFunds = data;
    },
    setTopUSDFunds(state, data) {
      state.funds.TopUSDFunds = data;
    },
    setTopEUROFunds(state, data) {
      state.funds.TopEUROFunds = data;
    },
    setTop5StarRating(state, data) {
      state.funds.Top5StarRating = data;
    },
    setTop4StarRating(state, data) {
      state.funds.Top4StarRating = data;
    },
    setTopDailyTradedFunds(state, data) {
      state.funds.TopDailyTradedFunds = data;
    },
    setMostActivelyBought(state, data) {
      state.funds.MostActivelyBought = data;
    },
    setMostActivelySold(state, data) {
      state.funds.MostActivelySold = data;
    },
    setFundSummaryMutualFunds(state, data) {
      state.funds.fundsSummary = data;
    },
    setFundSummaryETF(state, data) {
      state.ETFTopFive.fundsSummary = data;
    },
    setFundSummaryEquities(state, data) {
      state.equitiesTopFive.fundsSummary = data;
    },
    setETFTopPerformingFunds(state, data) {
      state.ETFTopFive.TopPerformingFunds = data;
    },
    setETFTopGBPFunds(state, data) {
      state.ETFTopFive.TopGBPFunds = data;
    },
    setETFTopUSDFunds(state, data) {
      state.ETFTopFive.TopUSDFunds = data;
    },
    setETFTopEUROFunds(state, data) {
      state.ETFTopFive.TopEUROFunds = data;
    },
    setETFTop5StarRating(state, data) {
      state.ETFTopFive.Top5StarRating = data;
    },
    setETFTop4StarRating(state, data) {
      state.ETFTopFive.Top4StarRating = data;
    },
    setETFTopDailyTradedFunds(state, data) {
      state.ETFTopFive.TopDailyTradedFunds = data;
    },
    setETFMostActivelyBought(state, data) {
      state.ETFTopFive.MostActivelyBought = data;
    },
    setETFMostActivelySold(state, data) {
      state.ETFTopFive.MostActivelySold = data;
    },
    setETFFundSummary(state, data) {
      state.ETFTopFive.fundsSummary = data;
    },
    setEquitiesTopPerformingFunds(state, data) {
      state.equitiesTopFive.TopPerformingFunds = data;
    },
    setEquitiesTopGBPFunds(state, data) {
      state.equitiesTopFive.TopGBPFunds = data;
    },
    setEquitiesTopUSDFunds(state, data) {
      state.equitiesTopFive.TopUSDFunds = data;
    },
    setEquitiesTopEUROFunds(state, data) {
      state.equitiesTopFive.TopEUROFunds = data;
    },
    setEquitiesTop5StarRating(state, data) {
      state.equitiesTopFive.Top5StarRating = data;
    },
    setEquitiesTop4StarRating(state, data) {
      state.equitiesTopFive.Top4StarRating = data;
    },
    setEquitiesTopDailyTradedFunds(state, data) {
      state.equitiesTopFive.TopDailyTradedFunds = data;
    },
    setEquitiesMostActivelyBought(state, data) {
      state.equitiesTopFive.MostActivelyBought = data;
    },
    setEquitiesMostActivelySold(state, data) {
      state.equitiesTopFive.MostActivelySold = data;
    },
    setEquitiesFundSummary(state, data) {
      state.equitiesTopFive.fundsSummary = data;
    },

    setETFs(state, data) {
      state.ETFs = data;
    },
    setLowCostETFs(state, data) {
      state.lowCostETFs = data;
    },
    setDFMs(state, data) {
      state.DFMs = data;
    },
    setEquities(state, data) {
      state.equities = data;
    },
    setDFMDetails(state, data) {
      state.DFMDetails = data;
    },
    setFixedIncome(state, data) {
      state.fixedIncome = data;
    },
    setFixedIncomeProviders(state, data) {
      state.fixedIncomeProviders = data;
    },
    setActivelyManagedCertificates(state, data) {
      state.activelyManagedCertificates = data;
    },
    setActivelyManagedCertificateProviders(state, data) {
      state.activelyManagedCertificateProviders = data;
    },
  },
  actions: {
    async getProductFilterOptions({ commit }) {
      const res = await axios
        .get(
          endpoints.productOptions +
            '?whitelabelID=' +
            parseInt(this.state.account.details.whiteLabelId, 10),
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          commit('setProductFilterOptions', response.data.Data.Groups);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading product filter options',
          );
          this.dispatch('addError', msg);
          commit('setProductFilterOptions', []);
        });
    },
    async getAdvancedFilteredProductOptions({ commit }) {
      let url: string =
        '?whitelabelID=' +
        parseInt(this.state.account.details.whiteLabelId, 10) +
        '&searchCriteria.userInfoId=' +
        this.state.account.details.userId +
        '&searchCriteria.platformID=' +
        this.state.account.details.activeAccountId;
      if (this.state.products.productFiltersQueryString) {
        url = url + this.state.products.productFiltersQueryString;
      }
      if (this.state.products.productSearchKeyword) {
        url =
          url +
          ('&searchCriteria.keyword=' +
            this.state.products.productSearchKeyword);
      }

      const res = await axios
        .get(endpoints.productOptions + url, {
          headers: {
            Authorization: 'bearer ' + this.state.account.token,
          },
        })
        .then((response) => {
          commit('setProductFilterOptions', response.data.Data.Groups);
          return response.data.Data.Groups;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading product filter options',
          );
          this.dispatch('addError', msg);
          commit('setProductFilterOptions', []);
        });
    },

    async getProductSearchResults({ commit }, data) {
      commit('setFetching', true);
      commit('toggleSearchLoading', true);

      let url: string =
        '?whitelabelID=' +
        parseInt(this.state.account.details.whiteLabelId, 10) +
        '&searchCriteria.userInfoId=' +
        this.state.account.details.userId +
        '&searchCriteria.platformID=' +
        this.state.account.details.activeAccountId;
      if (this.state.products.productFiltersQueryString) {
        url = url + this.state.products.productFiltersQueryString;
      }
      data.pageSort
        ? (url = url + ('&pagingInfo.pageSort=' + data.pageSort))
        : (url = url + ('&pagingInfo.pageSort=' + 'YTD'));
      data.pageSize
        ? (url = url + ('&pagingInfo.pageSize=' + data.pageSize))
        : (url = url + ('&pagingInfo.pageSize=' + 20));
      data.pageNumber
        ? (url = url + ('&pagingInfo.pageNumber=' + data.pageNumber))
        : (url = url + ('&pagingInfo.pageNumber=' + 1));
      data.pageOrder
        ? (url = url + ('&pagingInfo.pageOrder=' + data.pageOrder))
        : (url = url + ('&pagingInfo.pageOrder=' + 'asc'));

      if (this.state.products.productSearchKeyword) {
        url =
          url +
          ('&searchCriteria.keyword=' +
            this.state.products.productSearchKeyword);
      }

      const res = await axios
        .get(endpoints.products + url, {
          headers: {
            Authorization: 'bearer ' + this.state.account.token,
          },
        })
        .then((response) => {
          commit('setProductSearchResults', []);
          if (
            !response.data.Data.ProductInformation ||
            response.data.Data.ProductInformation.length < 1
          ) {
            commit('setProductSearchResults', {
              CurrentPageTotalProducts: 0,
              TotalProducts: 0,
              ProductInformation: [],
            });
          } else {
            commit('setProductSearchResults', response.data.Data);
          }
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading product search results',
          );
          this.dispatch('addError', msg);
          commit('setProductSearchResults', []);
          this.commit('toggleSearchLoading', false);
          this.commit('setFetching', false);
        });
      // this.dispatch('setActiveTab', 'search-results');
      this.commit('toggleSearchLoading', false);
      this.commit('setFetching', false);
    },

    async getProducts({ commit }, data) {
      let url =
        endpoints.products +
        '?whitelabelID=' +
        parseInt(this.state.account.details.whiteLabelId, 10) +
        '&searchCriteria.userInfoId=' +
        this.state.account.details.userId +
        '&searchCriteria.platformID=' +
        this.state.account.details.activeAccountId +
        '&searchCriteria.productType=' +
        data.productType;
      if (data.pageSort) {
        url = url + ('&pagingInfo.pageSort=' + data.pageSort);
      }
      if (data.pageSize) {
        url = url + ('&pagingInfo.pageSize=' + data.pageSize);
      }
      if (data.pageNumber) {
        url = url + ('&pagingInfo.pageNumber=' + data.pageNumber);
      }
      if (data.pageOrder) {
        url = url + ('&pagingInfo.pageOrder=' + data.pageOrder);
      }
      if (data.isLowCostETF) {
        url = url + ('&searchCriteria.isLowCostETF=' + data.isLowCostETF);
      }
      const res = await axios
        .get(url, {
          headers: {
            Authorization: 'bearer ' + this.state.account.token,
          },
        })
        .then((response) => {
          commit(data.commitFn, response.data.Data);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading product list',
          );
          this.dispatch('addError', msg);
          commit(data.commitFn, []);
        });
    },
    async getTopFive({ commit }, data) {
      let url =
        endpoints.products +
        '?whitelabelID=' +
        parseInt(this.state.account.details.whiteLabelId, 10) +
        '&searchCriteria.userInfoId=' +
        this.state.account.details.userId +
        '&searchCriteria.platformID=' +
        this.state.account.details.activeAccountId +
        '&searchCriteria.productType=' +
        data.productType;
      if (data.pageSort) {
        url = url + ('&pagingInfo.pageSort=' + data.pageSort);
      }
      if (data.pageSize) {
        url = url + ('&pagingInfo.pageSize=' + data.pageSize);
      }
      if (data.pageNumber) {
        url = url + ('&pagingInfo.pageNumber=' + data.pageNumber);
      }
      if (data.pageOrder) {
        url = url + ('&pagingInfo.pageOrder=' + data.pageOrder);
      }
      if (data.mutualFundParam) {
        url = url + ('&mutualFundParam=' + data.mutualFundParam);
      }
      const res = await axios
        .get(url, {
          headers: {
            Authorization: 'bearer ' + this.state.account.token,
          },
        })
        .then((response) => {
          commit(data.commitFn, response.data.Data.ProductInformation);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading product tiles',
          );
          this.dispatch('addError', msg);
          commit(data.commitFn, []);
          return null;
        });
    },
    async getFundsSummary({ commit }, data) {
      const url =
        endpoints.productTotals +
        '?whitelabelID=' +
        parseInt(this.state.account.details.whiteLabelId, 10) +
        '&productType=' +
        data;
      const res = await axios
        .get(url, {
          headers: {
            Authorization: 'bearer ' + this.state.account.token,
          },
        })
        .then((response) => {
          commit('setFundSummary' + data, response.data.Data);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading funds summary',
          );
          this.dispatch('addError', msg);
          commit('setFundSummary' + data, null);
        });
    },
    async getNotesProviders({ commit }) {
      const res = await axios
        .get(
          endpoints.notesProviders +
            '?whitelabelID=' +
            parseInt(this.state.account.details.whiteLabelId, 10),
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          commit('setNotesProviders', response.data.Data);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading Structured Notes providers',
          );
          this.dispatch('addError', msg);
          commit('setNotesProviders', []);
        });
    },
    async getStructuredNotes({ commit }) {
      const res = await axios
        .get(
          endpoints.products +
            '?whitelabelID=' +
            parseInt(this.state.account.details.whiteLabelId, 10) +
            '&searchCriteria.userInfoId=' +
            this.state.account.details.userId +
            '&searchCriteria.platformID=' +
            this.state.account.details.activeAccountId +
            '&pagingInfo.pageSize=-1' +
            '&searchCriteria.productType=Note',
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          commit(
            'setStructuredNotes',
            response.data?.Data?.ProductInformation ?? [],
          );
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading Structured Notes',
          );
          this.dispatch('addError', msg);
          commit('setStructuredNotes', []);
        });
    },
    async getFixedIncome({ commit }, search) {
      const res = await axios
        .get(
          endpoints.fixedIncome +
            '?whitelabelID=' +
            parseInt(this.state.account.details.whiteLabelId, 10),
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          if (search) {
            commit('setProductSearchResults', response.data.Data);
          } else {
            commit('setFixedIncome', response.data.Data);
          }
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading Fixed Income Bonds',
          );
          this.dispatch('addError', msg);
          commit('setFixedIncome', null);
        });
    },
    async getFixedIncomeProviders({ commit }) {
      const res = await axios
        .get(
          endpoints.fixedIncomeProviders +
            '?whitelabelID=' +
            parseInt(this.state.account.details.whiteLabelId, 10),
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          commit('setFixedIncomeProviders', response.data.Data);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading Fixed Income Fund Providers',
          );
          this.dispatch('addError', msg);
          commit('setFixedIncomeProviders', []);
        });
    },
    async getDFMs({ commit }, search) {
      const res = await axios
        .get(
          endpoints.dfm +
            '?whitelabelID=' +
            parseInt(this.state.account.details.whiteLabelId, 10),
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          if (search) {
            commit('setProductSearchResults', response.data.Data);
          } else {
            commit('setDFMs', response.data.Data);
          }
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading DFMs',
          );
          console.warn(msg);
          // this.dispatch('addError', msg);
          commit('setDFMs', []);
        });
    },
    async getEquities({ commit }, search) {
      const res = await axios
        .get(endpoints.equities, {
          headers: {
            Authorization: 'bearer ' + this.state.account.token,
          },
        })
        .then((response) => {
          commit('setEquities', response.data.Data[0].EquityProducts);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading DFMs',
          );
          commit('setEquities', []);
        });
    },
    async getActivelyManagedCertificates({ commit }) {
      await axios
        .get(endpoints.amc, {
          headers: {
            Authorization: 'bearer ' + this.state.account.token,
          },
        })
        .then((response) => {
          commit('setActivelyManagedCertificates', response.data.Data);
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading Gold AMC certificates',
          );
          this.dispatch('addError', msg);
          commit('setActivelyManagedCertificates', []);
        });
    },
    async getActivelyManagedCertificateProviders({ commit }) {
      await axios
        .get(endpoints.amcProviders, {
          headers: {
            Authorization: 'bearer ' + this.state.account.token,
          },
        })
        .then((response) => {
          commit('setActivelyManagedCertificateProviders', response.data.Data);
        })
        .catch((err) => {
          const msg = handleError(
            err,
            'Sorry! Looks like something went wrong while loading Gold AMC providers',
          );
          this.dispatch('addError', msg);
          commit('setActivelyManagedCertificateProviders', []);
        });
    },
    async setDFMDetails({ commit }, data) {
      commit('setDFMDetails', data);
    },
  },
};
